var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99966 10.8877C8.26932 10.8877 8.5027 10.9905 8.69966 11.1966C8.89963 11.4027 8.99966 11.6507 8.99966 11.9405C8.99966 12.137 8.95295 12.3159 8.85903 12.4769C8.76813 12.6379 8.64646 12.7664 8.49497 12.863C8.3465 12.9564 8.18145 13.0033 7.99966 13.0033C7.72391 13.0033 7.48724 12.9005 7.29028 12.6944C7.09634 12.4883 6.99966 12.2368 6.99966 11.9405C6.99966 11.6507 7.09641 11.4027 7.29028 11.1966C7.48725 10.9905 7.7239 10.8877 7.99966 10.8877Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73589 9.79282C8.73355 9.90158 8.64472 9.98852 8.53594 9.98852H7.46351C7.35467 9.98852 7.26581 9.9015 7.26355 9.79268L6.71189 3.20722C6.70955 3.09516 6.79976 3.00306 6.91184 3.00306L9.00024 3.00293C9.11238 3.00293 9.2026 3.09511 9.20019 3.20722L8.73589 9.79282Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.0fab8f323e79e338bbcda9d387826569.svg";
export { ForwardRef as ReactComponent };